// extracted by mini-css-extract-plugin
export default {"hideTooltip":"g--z","fadeIn":"h--z","delay":"i--z","recommendedSizeTooltip":"j--z"};